var _style, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26.5 20.8",
    style: {
      enableBackground: "new 0 0 26.5 20.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2A275C;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.2,0c3.5,0,7.1,0,10.6,0c1.8,0,3.2,1.5,2.4,3.6c-0.5,1.2-1.3,2.1-2.4,2.8c-2.7,1.9-5.5,3.8-8.2,5.7 c-0.4,0.3-0.9,0.6-1.4,0.8c-0.8,0.4-1.6,0.3-2.3-0.1c-1.1-0.7-2.1-1.4-3.2-2.1c-2.2-1.5-4.3-3-6.4-4.5c-1-0.7-1.8-1.7-2.2-2.9 c-0.3-1.1,0.2-2.8,1.4-3.1C1.8,0.1,2.2,0,2.5,0C6.1,0,9.6,0,13.2,0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.6,20.2c-0.4,0.3-0.8,0.5-1.3,0.5c-0.1,0-0.3,0-0.4,0c-7.1,0-14.2,0-21.3,0c-0.6,0-1.2-0.1-1.7-0.6 c2.5-2.5,5-5,7.5-7.5c0.4,0.3,0.8,0.5,1.1,0.8c0.8,0.6,1.7,1.1,2.7,1.4c0.8,0.2,1.6,0.2,2.4-0.1c1.1-0.4,2.1-1.1,3.1-1.8 c0.2-0.1,0.3-0.2,0.5-0.4C20.6,15.2,23.1,17.7,25.6,20.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.5,11.5C4.4,13.7,2.2,15.8,0,18V6.8c0,0,0,0,0,0c1.1,1.1,2.4,1.8,3.6,2.7C4.6,10.2,5.6,10.8,6.5,11.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.4,6.8v11.2c-2.1-2.1-4.3-4.3-6.5-6.5C22,9.9,24.4,8.6,26.4,6.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail_icon.38b72ed49f320366544de1e447df8f4c.svg";
export { ForwardRef as ReactComponent };